import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';
import { AcknowledgementSettings } from 'views/App/Portal/Policy/_types/acknowledgements';

export default function useManageAcknowledgementSettings() {
  const update = async (
    manualId: string,
    data: AcknowledgementSettings,
    callback?: (data: AcknowledgementSettings) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexipub/acknowledgements/v1/admin/manuals/${manualId}/default-config`;
    await fetcher({
      url,
      method: 'put',
      body: data,
    })
      .then((data) => {
        if (callback) callback(data);
      })
      .catch((err) => {
        console.warn('update err', err);
        if (onError) handleError(err, { onError });
      });
  };

  return {
    update,
  };
}
